<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';

import { EDUCATORS_ROUTE_SIGNUP } from '~/constants/routes/educators';
import { useConfigStore } from '~/stores/config';

const { t } = useI18n();
const route = useRoute();
const configStore = useConfigStore();
const analytics = useAnalyticsService();

const trackClick = () => {
  analytics.track(EVENTS.SCHOOLS_LANDING_CTA_CLICKED, { cta: 'nav_create_account', page: route.path });
};
</script>

<template>
  <Button
    v-if="configStore.teacherRegistrationOpen"
    variant="secondary"
    class="hidden sm:inline-flex font-semibold"
    as-child
  >
    <NuxtLink
      :to="EDUCATORS_ROUTE_SIGNUP"
      data-testid="schools-create-account-link"
      @click="trackClick"
    >
      {{ t('schools.landing.nav.createAccount') }}
    </NuxtLink>
  </Button>
</template>
